<p-tabMenu [scrollable]="scrollable" [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)">
  <ng-template pTemplate="item" let-item let-i="index">
    <!-- Here you can add the item.icon, item.notification, etc... -->
    {{ item.label }}
  </ng-template>
</p-tabMenu>
